import clsx from "clsx";
import s from "./styles.module.sass";
import expandIcon from "../../../../public/icons/extend.svg";
import Image from "next/image";
import { FC, memo, ReactNode, useState } from "react";

interface IAccordion {
	titleChildren: ReactNode;
	children: ReactNode;
	variant?: "outlined" | "filled";
	disabled?: boolean;
	isOpenByDefault?: boolean;
}

const Accordion: FC<IAccordion> = ({
	titleChildren,
	children,
	variant,
	disabled,
	isOpenByDefault = false,
}) => {
	const [isAccordionOpen, setIsAccordionOpen] = useState(isOpenByDefault);

	const toggleAccordion = () => {
		setIsAccordionOpen((prev) => {
			return !prev;
		});
	};

	return (
		<div
			className={clsx(s.accordion, {
				[s.outlined]: variant === "outlined",
				[s.disabled]: disabled,
			})}
		>
			<button
				className={clsx(s.titleWrapper, {
					[s.filled]: variant === "filled",
				})}
				disabled={disabled}
				onClick={toggleAccordion}
			>
				{titleChildren}
				<div
					className={clsx(s.expandButton, {
						[s.opened]: isAccordionOpen,
					})}
				>
					<Image src={expandIcon} className={s.expandIcon} alt="Раскрыть" />
				</div>
			</button>
			<div
				className={clsx(s.content, {
					[s.hidden]: !isAccordionOpen,
				})}
			>
				{children}
			</div>
		</div>
	);
};

export default memo(Accordion);
